import React, { useState, useEffect } from 'react';
import { Button } from './button';
import { Input } from './input';
import { Search, Filter, X, RefreshCw } from 'lucide-react';

/**
 * Componente de filtros para configuraciones del sistema
 * Permite filtrar por clave, estado y búsqueda
 */
const ConfigFilters = ({
  filters = {},
  onFiltersChange,
  onClearFilters,
  onSearch,
  searchPlaceholder = 'Buscar por clave...',
  loading = false
}) => {
  // Estado local para los inputs
  const [localSearchTerm, setLocalSearchTerm] = useState(filters.search || '');
  const [localIsActive, setLocalIsActive] = useState(filters.isActive !== undefined ? filters.isActive : '');

  // Sincronizar estado local cuando cambian los filtros externos
  useEffect(() => {
    setLocalSearchTerm(filters.search || '');
    setLocalIsActive(filters.isActive !== undefined ? filters.isActive : '');
  }, [filters.search, filters.isActive]);

  // Manejar limpieza de filtros
  const handleClearFilters = () => {
    setLocalSearchTerm('');
    setLocalIsActive('');
    onClearFilters();
  };

  // Manejar cambio en el campo de búsqueda
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setLocalSearchTerm(value);
  };

  // Manejar cambio en el filtro de estado
  const handleStatusChange = (e) => {
    const value = e.target.value;
    setLocalIsActive(value);
  };

  // Aplicar filtros
  const handleApplyFilters = () => {
    onFiltersChange({
      ...filters,
      search: localSearchTerm,
      isActive: localIsActive === '' ? undefined : localIsActive === 'true',
      applyNow: true
    });
    onSearch();
  };

  // Verificar si hay filtros activos
  const hasActiveFilters = localSearchTerm !== '' || localIsActive !== '';

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex flex-col lg:flex-row gap-4">
        {/* Búsqueda por clave */}
        <div className="flex-1">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <Input
              type="text"
              placeholder={searchPlaceholder}
              value={localSearchTerm}
              onChange={handleSearchChange}
              className="pl-10"
              disabled={loading}
            />
          </div>
        </div>

        {/* Filtro por estado */}
        <div className="lg:w-48">
          <select
            value={localIsActive}
            onChange={handleStatusChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            disabled={loading}
          >
            <option value="">Todos los estados</option>
            <option value="true">Activo</option>
            <option value="false">Inactivo</option>
          </select>
        </div>

        {/* Botones de acción */}
        <div className="flex gap-2">
          <Button
            onClick={handleApplyFilters}
            disabled={loading}
            className="bg-blue-600 hover:bg-blue-700 flex items-center gap-2"
          >
            {loading ? (
              <RefreshCw className="w-4 h-4 animate-spin" />
            ) : (
              <Filter className="w-4 h-4" />
            )}
            {loading ? 'Aplicando...' : 'Aplicar'}
          </Button>

          {hasActiveFilters && (
            <Button
              onClick={handleClearFilters}
              variant="outline"
              disabled={loading}
              className="flex items-center gap-2"
            >
              <X className="w-4 h-4" />
              Limpiar
            </Button>
          )}
        </div>
      </div>


    </div>
  );
};

export default ConfigFilters; 